// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"8e26cd0c","461":"aed86b54","958":"6e99d229"}[chunkId] + ".chunk.css";
};